import React, { useRef } from "react";
import { ConfirmationDialogParams } from "./ConfirmationDialog";
import ConfirmationDialogHolder, { ConfirmationDialogHolderRef } from "./ConfirmationDialogHolder";
import HiddenError from "../../../models/HiddenError";

export interface ConfirmationDialogContextType {
  showConfirmationDialog: (params?: ConfirmationDialogParams) => Promise<string>;
}

export const ConfirmationDialogContext = React.createContext<ConfirmationDialogContextType>({
  showConfirmationDialog: () => Promise.reject(),
});

export const ConfirmationDialogContextProvider: React.FunctionComponent<{
  children?: JSX.Element;
}> = (props) => {
  const confirmationDialog = useRef<ConfirmationDialogHolderRef | null>(null);

  const showConfirmationDialog = (params?: ConfirmationDialogParams): Promise<string> => {
    if (confirmationDialog.current?.isOpen()) {
      confirmationDialog.current?.cancel();
    }
    return new Promise((resolve, reject) => {
      confirmationDialog.current?.show({
        open: true,
        onCancel: () => {
          reject(new HiddenError("Dialog closed."));
          confirmationDialog.current?.hide();
        },
        onConfirm: (id: string) => {
          resolve(id);
          confirmationDialog.current?.hide();
        },
        ...params,
      });
    });
  };

  const { children } = props;

  return (
    <ConfirmationDialogContext.Provider
      value={{
        showConfirmationDialog,
      }}
    >
      {children}
      <ConfirmationDialogHolder ref={confirmationDialog} />
    </ConfirmationDialogContext.Provider>
  );
};

export default ConfirmationDialogContext;
